module.exports = __webpack_public_path__ + "img/france2.edf97767.jpg";